import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import ModalAtendimentosProntuario from '../Modals/ModalAtendimentosProntuario';

// Pergunta e modal do atendimento, por cima do modal do agendamento (estado em useAgendamentoAttendance)
const AgendamentoAttendance = ({ attendance }) => {
  const [loading, setLoading] = useState(false); // busca de doutores do campo Doutor
  const { form, question, modal, saving } = attendance;

  return (
    <>
      <Modal show={question.show} onHide={() => attendance.answer(null)} centered backdrop='static'>
        <Modal.Header closeButton closeLabel='Voltar ao agendamento'>
          <Modal.Title as='h5'>Lançar atendimento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Deseja lançar um atendimento no prontuário?
          {question.prontuario ? <small className='d-block text-muted mt-2'>{question.prontuario}</small> : ''}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='outline-secondary' onClick={() => attendance.answer('no')}>Não</Button>
          <Button variant='success' autoFocus onClick={() => attendance.answer('yes')}>Sim</Button>
        </Modal.Footer>
      </Modal>

      <ModalAtendimentosProntuario
        showModal={modal.show}
        handleCloseModal={attendance.close}
        register={form.register}
        setValue={form.setValue}
        getValues={form.getValues}
        loading={loading}
        setLoading={setLoading}
        showDeleteButton={false}
        salvar={attendance.submit}
        saving={saving}
        title={<>
          Novo atendimento
          {modal.prontuario ? <small className='d-block text-muted fs-6 fw-normal'>{modal.prontuario}</small> : ''}
        </>}
      />
    </>
  );
};

export default AgendamentoAttendance;
